<!--
# -----------------------------------------------------------------------------
# Component: Accounts.vue
# Author: antonio.ramirez@pst.sg
# Created Date: 02/April/2019
# Comments: Manage Accounts Module
# -----------------------------------------------------------------------------
-->
<template>
  <page :load="doInitAccounts">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs7 md9 lg10>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
      </v-layout>
      <message :messages="messages"></message>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="accountsTransFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for Accounts
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <!--1st Row-->
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-autocomplete
                            :items="transactions"
                            v-model="accountsTransForm.transactions"
                            :label="accountsTransFormLabel.transactions"
                            item-text="label"
                            item-value="value"
                            data-vv-name="accountsTransForm.transactions"
                            :data-vv-as="accountsTransFormLabel.transactions"
                            :error-messages="errors.collect('accountsTransForm.transactions')"
                            clearable
                            @change="doTranType"
                            :disabled="
                              accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-autocomplete
                            :items="actions"
                            v-model="accountsTransForm.actions"
                            :label="accountsTransFormLabel.actions"
                            item-text="label"
                            item-value="value"
                            data-vv-name="accountsTransForm.actions"
                            :data-vv-as="accountsTransFormLabel.actions"
                            :error-messages="errors.collect('actions')"
                            clearable
                            @change="doAction"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-checkbox
                            color="primary"
                            :label="accountsTransFormLabel.includeBalance"
                            v-model="accountsTransForm.includeBalance"
                            :disabled="
                              accountsTransForm.actions === 'Review' ||
                                accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER' ||
                                accountsTransForm.actionName === 'NON_TRADE_FILTER'
                            "
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg6-custom">
                          <v-checkbox
                            color="primary"
                            :label="accountsTransFormLabel.includeVoidTransactions"
                            v-model="accountsTransForm.includeVoidTransactions"
                            :disabled="
                              accountsTransForm.actions === 'Review' ||
                                accountsTransForm.transactions === 'Underwriting' ||
                                accountsTransForm.transactions === 'Claims' ||
                                accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER'
                            "
                          ></v-checkbox>
                        </v-flex>

                        <!--2nd Row-->
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-autocomplete
                            :items="branches"
                            v-model="accountsTransForm.branch"
                            :label="accountsTransFormLabel.branch"
                            item-text="label"
                            item-value="value"
                            data-vv-name="accountsTransForm.branch"
                            :data-vv-as="accountsTransFormLabel.branch"
                            :error-messages="errors.collect('accountsTransForm.branch')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 sm4 md3 x8 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.accountNo"
                            :label="accountsTransFormLabel.accountNo"
                            :error-messages="errors.collect('accountsTransForm.accountNo')"
                            data-vv-name="accountsTransForm.accountNo"
                            :data-vv-as="accountsTransFormLabel.accountNo"
                            v-validate="'entry|max:60'"
                            :disabled="accountsTransForm.actionName === 'COMM_FILTER'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showAcctNoHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.documentNo"
                            :label="accountsTransFormLabel.documentNo"
                            :error-messages="errors.collect('accountsTransForm.documentNo')"
                            data-vv-name="accountsTransForm.documentNo"
                            :data-vv-as="accountsTransFormLabel.documentNo"
                            v-validate="'entry|max:60'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showDocNoHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-autocomplete
                            :items="transactionType"
                            v-model="accountsTransForm.transactionType"
                            :label="accountsTransFormLabel.transactionType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="accountsTransForm.transactionType"
                            :data-vv-as="accountsTransFormLabel.transactionType"
                            :error-messages="errors.collect('accountsTransForm.transactionType')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.fund"
                            :label="accountsTransFormLabel.fund"
                            :error-messages="errors.collect('accountsTransForm.fund')"
                            data-vv-name="accountsTransForm.fund"
                            :data-vv-as="accountsTransFormLabel.fund"
                            v-validate="'entry|max:60'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showFundHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>

                        <!--3rd Row-->
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <cal-picker
                            v-model="accountsTransForm.transactionDate"
                            :label="accountsTransFormLabel.transactionDate"
                            :data-vv-as="accountsTransFormLabel.transactionDate"
                            data-vv-name="accountsTransForm.transactionDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.currency"
                            :label="accountsTransFormLabel.currency"
                            :error-messages="errors.collect('accountsTransForm.currency')"
                            data-vv-name="accountsTransForm.currency"
                            :data-vv-as="accountsTransFormLabel.currency"
                            v-validate="'entry|max:60'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showCurrHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.accountNoSuffix"
                            :label="accountsTransFormLabel.accountNoSuffix"
                            :error-messages="errors.collect('accountsTransForm.accountNoSuffix')"
                            data-vv-name="accountsTransForm.accountNoSuffix"
                            :data-vv-as="accountsTransFormLabel.accountNoSuffix"
                            v-validate="'entry|max:60'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showAcctSufHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.policyNo"
                            :label="accountsTransFormLabel.policyNo"
                            :error-messages="errors.collect('accountsTransForm.policyNo')"
                            data-vv-name="accountsTransForm.policyNo"
                            :data-vv-as="accountsTransFormLabel.policyNo"
                            v-validate="'entry|max:60'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showPolicyHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.claimNo"
                            :label="accountsTransFormLabel.claimNo"
                            :error-messages="errors.collect('accountsTransForm.claimNo')"
                            data-vv-name="accountsTransForm.claimNo"
                            :data-vv-as="accountsTransFormLabel.claimNo"
                            v-validate="'entry|max:60'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showClmHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>

                        <!--4th Row-->
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <cal-picker
                            v-model="accountsTransForm.dueDate"
                            :disabled="
                              accountsTransForm.actions !== 'Instalments' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                            :label="accountsTransFormLabel.dueDate"
                            :data-vv-as="accountsTransFormLabel.dueDate"
                            data-vv-name="dueDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.netAmount"
                            :label="accountsTransFormLabel.netAmount"
                            :error-messages="errors.collect('accountsTransForm.netAmount')"
                            data-vv-name="accountsTransForm.netAmount"
                            :data-vv-as="accountsTransFormLabel.netAmount"
                            v-validate="'entry|max:60|mask_decimal:2'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.osBalance"
                            :label="accountsTransFormLabel.osBalance"
                            :error-messages="errors.collect('accountsTransForm.osBalance')"
                            data-vv-name="accountsTransForm.osBalance"
                            :data-vv-as="accountsTransFormLabel.osBalance"
                            v-validate="'entry|max:60|mask_decimal:2'"
                            :disabled="
                              accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.bankNo"
                            :label="accountsTransFormLabel.bankNo"
                            :error-messages="errors.collect('accountsTransForm.bankNo')"
                            data-vv-name="accountsTransForm.bankNo"
                            :data-vv-as="accountsTransFormLabel.bankNo"
                            v-validate="'entry|max:60'"
                            :disabled="
                              accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showBankNoHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.payersChequeNo"
                            :label="accountsTransFormLabel.payersChequeNo"
                            :error-messages="errors.collect('accountsTransForm.payersChequeNo')"
                            data-vv-name="accountsTransForm.payersChequeNo"
                            :data-vv-as="accountsTransFormLabel.payersChequeNo"
                            v-validate="'entry|max:60'"
                            :disabled="
                              accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showPayersChequeNoHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>

                        <!--5th Row-->
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <cal-picker
                            v-model="accountsTransForm.lastMatchedDate"
                            :disabled="
                              accountsTransForm.actions !== 'Matched' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                            :label="accountsTransFormLabel.lastMatchedDate"
                            :data-vv-as="accountsTransFormLabel.lastMatchedDate"
                            data-vv-name="lastMatchedDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.gstRate"
                            :label="accountsTransFormLabel.gstRate"
                            :error-messages="errors.collect('accountsTransForm.gstRate')"
                            data-vv-name="accountsTransForm.gstRate"
                            :data-vv-as="accountsTransFormLabel.gstRate"
                            v-validate="'entry|max:60|mask_decimal:2'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.accountingYear"
                            :label="accountsTransFormLabel.accountingYear"
                            :error-messages="errors.collect('accountsTransForm.accountingYear')"
                            data-vv-name="accountsTransForm.accountingYear"
                            :data-vv-as="accountsTransFormLabel.accountingYear"
                            v-validate="'entry|numeric|mask_min_value:2001|mask_max_value:2098'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.accountingMonth"
                            :label="accountsTransFormLabel.accountingMonth"
                            :error-messages="errors.collect('accountsTransForm.accountingMonth')"
                            data-vv-name="accountsTransForm.accountingMonth"
                            :data-vv-as="accountsTransFormLabel.accountingMonth"
                            v-validate="'entry|numeric|mask_min_value:1|mask_max_value:13'"
                            :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                          <v-text-field
                            v-model="accountsTransForm.addressedTo"
                            :label="accountsTransFormLabel.addressedTo"
                            :error-messages="errors.collect('accountsTransForm.addressedTo')"
                            data-vv-name="accountsTransForm.addressedTo"
                            :data-vv-as="accountsTransFormLabel.addressedTo"
                            v-validate="'entry|max:60'"
                            :disabled="
                              accountsTransForm.actionName === 'GL_TRANS_FILTER' ||
                                accountsTransForm.actionName === 'MCH_DET_FILTER' ||
                                accountsTransForm.actionName === 'COMM_FILTER'
                            "
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showAddrToHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <transition name="slide-x-transition" mode="out-in">
                        <v-layout row wrap v-if="showDetailFilters">
                          <!--Hidden - 6th Row -->
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.batchNo"
                              :label="accountsTransFormLabel.batchNo"
                              :error-messages="errors.collect('accountsTransForm.batchNo')"
                              data-vv-name="accountsTransForm.batchNo"
                              :data-vv-as="accountsTransFormLabel.batchNo"
                              v-validate="'entry|numeric|mask_min_value:0'"
                              :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-autocomplete
                              :items="glInterface"
                              v-model="accountsTransForm.glInterface"
                              :label="accountsTransFormLabel.glInterface"
                              item-text="label"
                              item-value="value"
                              data-vv-name="accountsTransForm.glInterface"
                              :data-vv-as="accountsTransFormLabel.glInterface"
                              :error-messages="errors.collect('accountsTransForm.glInterface')"
                              clearable
                              :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <!--<v-text-field v-model="accountsTransForm.contraJournalNo" :label="accountsTransFormLabel.contraJournalNo" :error-messages="errors.collect('accountsTransForm.contraJournalNo')" data-vv-name="accountsTransForm.contraJournalNo" :data-vv-as="accountsTransFormLabel.contraJournalNo" @input="doChkSeqNo('CJ')" v-validate="contraJrnlValidation" :disabled="(accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'COMM_FILTER')"></v-text-field>-->
                            <v-text-field
                              v-model="accountsTransForm.contraJournalNo"
                              :label="accountsTransFormLabel.contraJournalNo"
                              :error-messages="errors.collect('accountsTransForm.contraJournalNo')"
                              data-vv-name="accountsTransForm.contraJournalNo"
                              :data-vv-as="accountsTransFormLabel.contraJournalNo"
                              v-validate="'entry|numeric|mask_min_value:0'"
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-autocomplete
                              :items="commissionType"
                              v-model="accountsTransForm.commissionType"
                              :label="accountsTransFormLabel.commissionType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="accountsTransForm.commissionType"
                              :data-vv-as="accountsTransFormLabel.commissionType"
                              :error-messages="errors.collect('accountsTransForm.commissionType')"
                              clearable
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'MCH_DET_FILTER'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.billingAccountNo"
                              :label="accountsTransFormLabel.billingAccountNo"
                              :error-messages="errors.collect('accountsTransForm.billingAccountNo')"
                              data-vv-name="accountsTransForm.billingAccountNo"
                              :data-vv-as="accountsTransFormLabel.billingAccountNo"
                              v-validate="'entry|max:60'"
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'MCH_DET_FILTER'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showBillAcctNoHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>

                          <!--Hidden - 7th Row -->
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.glAccountNo"
                              :label="accountsTransFormLabel.glAccountNo"
                              :error-messages="errors.collect('accountsTransForm.glAccountNo')"
                              data-vv-name="accountsTransForm.glAccountNo"
                              :data-vv-as="accountsTransFormLabel.glAccountNo"
                              v-validate="'entry|max:60'"
                              :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showGlAcctNoHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.glJournalNo"
                              :label="accountsTransFormLabel.glJournalNo"
                              :error-messages="errors.collect('accountsTransForm.glJournalNo')"
                              data-vv-name="accountsTransForm.glJournalNo"
                              :data-vv-as="accountsTransFormLabel.glJournalNo"
                              v-validate="'entry|numeric|mask_min_value:0'"
                              :disabled="accountsTransForm.actionName === 'MCH_DET_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.contraDocumentNo"
                              :label="accountsTransFormLabel.contraDocumentNo"
                              :error-messages="errors.collect('accountsTransForm.contraDocumentNo')"
                              data-vv-name="accountsTransForm.contraDocumentNo"
                              :data-vv-as="accountsTransFormLabel.contraDocumentNo"
                              v-validate="'entry|max:60'"
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'COMM_FILTER'"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <!--<v-text-field v-model="accountsTransForm.commissionNo" :label="accountsTransFormLabel.commissionNo" :error-messages="errors.collect('accountsTransForm.commissionNo')" data-vv-name="accountsTransForm.commissionNo" :data-vv-as="accountsTransFormLabel.commissionNo" @input="doChkSeqNo('CPV')" v-validate="commValidation" :disabled="(accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'MCH_DET_FILTER')"></v-text-field>-->
                            <v-text-field
                              v-model="accountsTransForm.commissionNo"
                              :label="accountsTransFormLabel.commissionNo"
                              :error-messages="errors.collect('accountsTransForm.commissionNo')"
                              data-vv-name="accountsTransForm.commissionNo"
                              :data-vv-as="accountsTransFormLabel.commissionNo"
                              v-validate="'entry|numeric|mask_min_value:0'"
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'MCH_DET_FILTER'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 class="lg5-custom">
                            <v-text-field
                              v-model="accountsTransForm.overridingAccountNo"
                              :label="accountsTransFormLabel.overridingAccountNo"
                              :error-messages="errors.collect('accountsTransForm.overridingAccountNo')"
                              data-vv-name="accountsTransForm.overridingAccountNo"
                              :data-vv-as="accountsTransFormLabel.overridingAccountNo"
                              v-validate="'entry|max:60'"
                              :disabled="accountsTransForm.actionName === 'GL_TRANS_FILTER' || accountsTransForm.actionName === 'MCH_DET_FILTER'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showOvrdAcctNoHelpList = true">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </transition>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      @click.native="showDetailFilters = true"
                      v-if="!showDetailFilters"
                      :disabled="accountsTransForm.actionName === 'ACCT_MASTER_FILTER' || accountsTransForm.actionName === 'NON_TRADE_FILTER'"
                      >Show More Filters</v-btn
                    >
                    <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters">Show Less Filters</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-tabs v-model="tab">
              <!--Search Results-->
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" @click="doColumn(detailTab, columns)">{{ detailTab }}</v-tab>
              <v-spacer></v-spacer>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text ma-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text v-if="accountsTransForm.actionName === 'ACCT_MASTER_FILTER'">
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedAccountsColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                  <v-card-text v-if="accountsTransForm.actionName === 'GL_TRANS_FILTER'">
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedGLColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                  <v-card-text v-if="accountsTransForm.actionName === 'MCH_DET_FILTER'">
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedMDColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                  <v-card-text v-if="accountsTransForm.actionName === 'COMM_FILTER'">
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedCommColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                  <v-card-text v-if="accountsTransForm.actionName === 'NON_TRADE_FILTER'">
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedNonTradeColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-btn class="mr-2 mt-2" v-if="checkAccess([permissionKeys.perm_041235])" color="info" @click.native="doExportFilters">
                <span>{{ labels.exportList }}</span>
                <v-icon right dark>mdi-file-excel</v-icon>
              </v-btn>
            </v-tabs>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item :key="1">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listAccountsHeaders"
                      v-bind:items="itemsAM"
                      :server-items-length="totalItemsAM"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationAM"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedAccountsColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="
                                (doShowAction1(row.item) || doShowAction2(row.item) || doShowAction3(row.item)) &&
                                  checkAccess([permissionKeys.perm_041160])
                              "
                              @query="doQuery(row)"
                              :review="doShowAction1(row.item) && checkAccess([permissionKeys.perm_041155])"
                              @review="doReview(row)"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listGLHeaders"
                      v-bind:items="itemsGL"
                      :server-items-length="totalItemsGL"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationGL"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedGLColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action :rowData="row" :query="checkAccess([permissionKeys.perm_041175])" @query="doGLQuery(row)"></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listMDHeaders"
                      v-bind:items="itemsMD"
                      :server-items-length="totalItemsMD"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationMD"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedMDColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="checkAccess([permissionKeys.perm_041190])"
                              @query="doMatchedQuery(row)"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="4">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listCommHeaders"
                      v-bind:items="itemsCM"
                      :server-items-length="totalItemsCM"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationCM"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedCommColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="checkAccess([permissionKeys.perm_041205])"
                              @query="doCommPVQuery(row)"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="5">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listNonTradeHeaders"
                      v-bind:items="itemsNonTrade"
                      :server-items-length="totalItemsNonTrade"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationNonTrade"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedNonTradeColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="checkAccess([permissionKeys.perm_041230])"
                              @query="doNonTradeQuery(row) && checkAccess([permissionKeys.perm_041230])"
                              :review="doShowNonTradeReviewAction(row.item) && checkAccess([permissionKeys.perm_041225])"
                              @review="doNonTradeReview(row) && checkAccess([permissionKeys.perm_041225])"
                              :remove="checkAccess([permissionKeys.perm_041220])"
                              @remove="doRemoveAccount(row.item) && checkAccess([permissionKeys.perm_041220])"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!--Added: 11/May  Show Acct No Help List -->
    <v-dialog v-model="showAcctNoHelpList" width="1280px">
      <acct-no-help-list
        @close="showAcctNoHelpList = false"
        :boolRefresh="showAcctNoHelpList"
        @assign-acct-no="assignAcctNo">
      </acct-no-help-list>
    </v-dialog>

    <!--Added: 11/May  Show Fund Help List -->
    <v-dialog v-model="showFundHelpList" width="1280px">
      <fund-help-list
        @close="showFundHelpList = false"
        :boolRefresh="showFundHelpList"
        @assign-fund="assignFund">
      </fund-help-list>
    </v-dialog>

    <!--Added: 11/May  Show Policy Help List -->
    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list
        @close="showPolicyHelpList = false"
        :boolRefresh="showPolicyHelpList"
        @assign-policy="assignPolicy"></policy-help-list>
    </v-dialog>

    <!--Added: 11/May  Show Claim Help List -->
    <v-dialog v-model="showClmHelpList" width="1280px">
      <claim-help-list
        @close="showClmHelpList = false"
        :boolRefresh="showClmHelpList"
        @assign-claim-no="assignClaimNo"></claim-help-list>
    </v-dialog>

    <!--Added: 11/May  Show DocNo Help List -->
    <v-dialog v-model="showDocNoHelpList" width="1280px">
      <doc-no-help-list
        :transaction="accountsTransForm.transactions"
        :action="accountsTransForm.actions"
        :boolRefresh="showDocNoHelpList"
        @close="showDocNoHelpList = false"
        @assign-doc-no="assignDocNo"
      ></doc-no-help-list>
    </v-dialog>

    <!--Added: 11/May  Show Currency Help List -->
    <v-dialog v-model="showCurrHelpList" width="1280px">
      <cr-currency-help-list
        @close="showCurrHelpList = false"
        :boolRefresh="showCurrHelpList"
        @assign-currency="assignCurrency">
      </cr-currency-help-list>
    </v-dialog>

    <!--Added: 12/May  Show Acct Suffix Help List -->
    <v-dialog v-model="showAcctSufHelpList" width="1280px">
      <acct-suf-help-list
        @close="showAcctSufHelpList = false"
        :boolRefresh="showAcctSufHelpList"
        @assign-acct-suf="assignAcctSuf">
      </acct-suf-help-list>
    </v-dialog>

    <!--Added: 12/May  Show Payers Cheq Help List -->
    <v-dialog v-model="showPayersChequeNoHelpList" width="1280px">
      <payers-cheq-help-list
        @close="showPayersChequeNoHelpList = false"
        :boolRefresh="showPayersChequeNoHelpList"
        @assign-payers-cheq="assignPayersCheq">
      </payers-cheq-help-list>
    </v-dialog>

    <!--Added: 12/May  Show Bank Help List -->
    <v-dialog v-model="showBankNoHelpList" width="1280px">
      <bank-help-list
        @close="showBankNoHelpList = false"
        @assign-bank="assignBank"
        :boolRefresh="showBankNoHelpList"
        :objData="bankHelpListScreen">
      </bank-help-list>
    </v-dialog>

    <!--Added: 12/May  Show Addressed To Help List -->
    <v-dialog v-model="showAddrToHelpList" width="1280px">
      <addressed-to-help-list @close="showAddrToHelpList = false" @assign-addressed-to="assignAddressedTo"></addressed-to-help-list>
    </v-dialog>

    <!--Added: 21/May  Show Bill Account No To Help List -->
    <v-dialog v-model="showBillAcctNoHelpList" width="1280px">
      <bill-acct-no-help-list @close="showBillAcctNoHelpList = false" @assign-bill-acct-no="assignBillAcctNo"></bill-acct-no-help-list>
    </v-dialog>

    <!--Added: 23/May  Show GL Account No To Help List -->
    <v-dialog v-model="showGlAcctNoHelpList" width="1280px">
      <gl-acct-no-help-list @close="showGlAcctNoHelpList = false" @assign-gl-acct-no="assignGlAcctNo"></gl-acct-no-help-list>
    </v-dialog>

    <!--Added: 23/May  Show Contra Document No To Help List -->
    <v-dialog v-model="showContraDocNoHelpList" width="1280px">
      <contra-doc-no-help-list @close="showContraDocNoHelpList = false" @assign-contra-doc-no="assignContraDocNo"></contra-doc-no-help-list>
    </v-dialog>

    <!--Added: 23/May  Show Overriding Account No To Help List -->
    <v-dialog v-model="showOvrdAcctNoHelpList" width="1280px">
      <ovrd-acct-no-help-list @close="showOvrdAcctNoHelpList = false" @assign-ovrd-acct-no="assignOvrdAcctNo"></ovrd-acct-no-help-list>
    </v-dialog>

    <v-dialog v-model="showGLDetail" width="1000px">
      <v-container fluid grid-list-lg>
        <GL-trans-detail @close="showGLDetail = false" :objData="glObjData" :boolRefresh="showGLDetail"/>
      </v-container>
    </v-dialog>

    <v-dialog v-model="showMatchDetail" width="1000px">
      <v-container fluid grid-list-lg>
        <matched-trans-detail @close="showMatchDetail = false" :objData="matchObjData" :boolRefresh="showMatchDetail"/>
      </v-container>
    </v-dialog>

    <v-dialog v-model="showCommPVDetail" width="1000px">
      <v-container fluid grid-list-lg>
        <comm-p-v-trans-detail  @close="showCommPVDetail = false" :objData="commPVObjData" :boolRefresh="showCommPVDetail"/>
      </v-container>
    </v-dialog>

    <confirm v-model="promptRemoveAccount" @ok="deleteAccount"> {{ accountsTransFormLabel.warnMsg }} - {{ acctNoToRemove }}? </confirm>

    <confirm v-model="promptRemoveAccount2" @ok="deleteAccount">
      {{ accountsTransFormLabel.warnMsg2 }}
    </confirm>
    <v-dialog v-model="promptCannotRemoveAccount" width="50%" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Warning
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                {{ accountsTransFormLabel.warnMsg }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Common Search Filter - Start -->
    <v-dialog v-model="showFilterList" width="800px" persistent>
      <SearchFilter
        :boolRefresh="showFilterList"
        :filterTitle="'Saved Filters - Accounts Listing'"
        @close="showFilterList = false"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></SearchFilter>
    </v-dialog>

    <v-dialog v-model="saveFilter" width="800px" persistent>
      <UpdateSearchFilter
        :boolRefresh="saveFilter"
        :dialogTitle="'Filter'"
        :actionName="'new'"
        :filters="accountsTransForm"
        @close="saveFilter = false"
        @reloadList="reloadList"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></UpdateSearchFilter>
    </v-dialog>
    <!-- Common Search Filter - End -->
     <warning v-model="exportList.promptFilterWarning" :label="exportList.promptFilterWarningMsg" @ok="exportList.cfmExportAcctList = true"/>
     <columns-selector v-if="exportList.cfmExportAcctList" :titleTabDet="this.getDetTab" :columns="columns" v-model="exportList.cfmExportAcctList" @export="doExportList"/>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { accountsListMixin } from '@/mixins/accounting/accountsListMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters, acctTrans, unwTrans, clmTrans, allTrans, accAction, glAction, commAction } from '@/mixins/accounting/accountsFilters'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import DocNoHelpList from '@/components/core/common/dialog/DocNoHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import PolicyHelpList from '@/components/core/common/dialog/PolicyHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import PayersCheqHelpList from '@/components/core/common/dialog/PayersCheqHelpList'
import AddressedToHelpList from '@/components/core/common/dialog/AddressedToHelpList'
import BillAcctNoHelpList from '@/components/core/common/dialog/BillAcctNoHelpList'
import GlAcctNoHelpList from '@/components/core/common/dialog/GlAcctNoHelpList'
import ContraDocNoHelpList from '@/components/core/common/dialog/ContraDocNoHelpList'
import OvrdAcctNoHelpList from '@/components/core/common/dialog/OvrdAcctNoHelpList'
import BankHelpList from '@/components/core/common/dialog/BankHelpList'
import GLTransDetail from '@/components/core/accounting/dialog/GLTransDetail'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import {
  ACCOUNTS_LOAD_DATA,
  DEBITNOTE_LOAD_DATA,
  CREDITNOTE_LOAD_DATA,
  PAYMENT_LOAD_DATA,
  RECEIPT_LOAD_DATA,
  NON_TRADE_LOAD_DATA
} from '@/store/types'
import MatchedTransDetail from '@/components/core/accounting/dialog/MatchedTransDetail'
import CommPVTransDetail from '@/components/core/accounting/dialog/CommPVTransDetail'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { expandURI } from '@/utils/ajax'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // Common Search Filter - Start
      filterCode: 'ACT',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      permissionKeys: permissionKeys,
      // Common Search Filter - End
      detailTabs: ['Accounts', 'GL Transactions', 'Matched Details', 'Commission', 'Non-Trade'],
      columns: [],
      acctNoToRemove: '',
      glObjData: {},
      promptRemoveAccount: false,
      promptRemoveAccount2: false,
      showGLDetail: false,
      showMatchDetail: false,
      matchObjData: {},
      showCommPVDetail: false,
      commPVObjData: {},
      showDetailaccountsTransForm: false,
      promptCannotRemoveAccount: false,
      tab: undefined,
      showDetailFilters: false,
      showNonTradeDetail: false,
      nonTradeObjData: {},
      cardMenu: [
        { text: 'Accounts', icon: 'mdi-file-document-box', name: 'accounts', params: { tab: 'accounts' }, access: '', default: true },
        { text: 'Receipt', icon: 'mdi-receipt', name: 'receipts', params: { tab: 'receipt' }, access: '', default: false },
        { text: 'Payment', icon: 'mdi-cash', name: 'payment', params: { tab: 'payment' }, access: '', default: false },
        { text: 'Credit Note', icon: 'mdi-credit-card', name: 'creditNote', params: { tab: 'creditnote' }, access: '', default: false },
        { text: 'Debit Note', icon: 'mdi-credit-card-multiple', name: 'debitNote', params: { tab: 'debitnote' }, access: '', default: false },
        { text: 'Non-Trade', icon: 'mdi-credit-card-multiple', name: 'nonTrade', params: { tab: 'nontrade' }, access: '', default: false }
      ],
      delAccountForm: {
        branch: '',
        documentNo: '',
        accountNo: '',
        accountNoSuffix: '',
        fund: '',
        transactionType: '',
        actionName: '',
        transactionType2: ''
      },
      warnMsg: '',
      warnMsg2: '',
      paginationAM: {
        sortDesc: [false],
        page: 1
      },
      getDetTab: undefined,
      labels: {
        exportList: 'Export List'
      },
      exportList: {
        selectorColumns: [],
        promptFilterWarning: false,
        cfmExportAcctList: false,
        promptFilterWarningMsg: 'Do you want to proceed without any filtering?'
      }
    }
  },
  watch: {
    tab: function(value) {
      if (value === 0) {
        this.doColumn('Accounts', this.columns)
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    initAccounts() {
      return this.$store.state.accounts.init
    }
  },
  methods: {
    async doInitAccounts() {
      await Promise.all([this.$store.dispatch('accountsInit')])
      if (this.initAccounts === 1) {
        this.doLoadActionList()
        this.bankHelpListScreen = 'screen_2'
        this.doTranType()
      }
      // Common Search Filter - Start
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_041005]) === true) {
        this.cardMenu.push({
          text: 'Accounts',
          icon: 'mdi-file-document-box',
          name: 'accounts',
          params: { tab: 'accounts' },
          access: '',
          default: true
        })
      }
      if (this.checkAccess([permissionKeys.perm_041015]) === true) {
        this.cardMenu.push({ text: 'Receipt', icon: 'mdi-receipt', name: 'receipts', params: { tab: 'receipt' }, access: '', default: false })
      }
      if (this.checkAccess([permissionKeys.perm_041050]) === true) {
        this.cardMenu.push({ text: 'Payment', icon: 'mdi-cash', name: 'payment', params: { tab: 'payment' }, access: '', default: false })
      }
      if (this.checkAccess([permissionKeys.perm_041085]) === true) {
        this.cardMenu.push({
          text: 'Credit Note',
          icon: 'mdi-credit-card',
          name: 'creditNote',
          params: { tab: 'creditnote' },
          access: '',
          default: false
        })
      }
      if (this.checkAccess([permissionKeys.perm_041115]) === true) {
        this.cardMenu.push({
          text: 'Debit Note',
          icon: 'mdi-credit-card-multiple',
          name: 'debitNote',
          params: { tab: 'debitnote' },
          access: '',
          default: false
        })
      }
      if (this.checkAccess([permissionKeys.perm_041215]) === true) {
        this.cardMenu.push({
          text: 'Non-Trade',
          icon: 'mdi-credit-card-multiple',
          name: 'nonTrade',
          params: { tab: 'nontrade' },
          access: '',
          default: false
        })
      }
      this.detailTabs = []
      if (this.checkAccess([permissionKeys.perm_041160]) === true) {
        this.detailTabs.push('Accounts')
      }
      if (this.checkAccess([permissionKeys.perm_041175]) === true) {
        this.detailTabs.push('GL Transactions')
      }
      if (this.checkAccess([permissionKeys.perm_041190]) === true) {
        this.detailTabs.push('Matched Details')
      }
      if (this.checkAccess([permissionKeys.perm_041205]) === true) {
        this.detailTabs.push('Commission')
      }
      if (this.checkAccess([permissionKeys.perm_041230]) === true) {
        this.detailTabs.push('Non-Trade')
      }
      if (this.detailTabs.length > 0) {
        this.getDetTab = this.detailTabs[0]
      }
      this.fetchBranchWBranchUserId()
      // Common Search Filter - End
    },
    // Common Search Filter - Start
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.performSearch()
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.accountsTransForm = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.performSearch(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.accountsTransForm = this.defaultFilter.filters
            }
          }
          this.firstTimeCalling = false
          this.performSearch(false)
        } catch (err) {
          this.loading = false
        }
      }
    },
    // Common Search Filter - End
    deleteAccount() {
      if (this.warnMsg !== '') {
        this.promptRemoveAccount = true
        this.warnMsg = ''
      } else if (this.warnMsg2 !== '') {
        this.promptRemoveAccount2 = true
        this.warnMsg2 = ''
      } else {
        this.fetchDelData(this.delAccountForm)
      }
    },
    doLoadActionList() {
      if (this.accountsTransForm.actionName === 'ACCT_MASTER_FILTER' || this.accountsTransForm.actionName === 'NON_TRADE_FILTER') {
        const accActionlist = Object.freeze(accAction)
        let convertAccActionArray = Object.keys(accActionlist).map(key => {
          return {
            label: accActionlist[key],
            value: key
          }
        })
        this.actions = convertAccActionArray
      } else if (this.accountsTransForm.actionName === 'GL_TRANS_FILTER') {
        const glActionlist = Object.freeze(glAction)
        let convertGlActionArray = Object.keys(glActionlist).map(key => {
          return {
            label: glActionlist[key],
            value: key
          }
        })
        this.actions = convertGlActionArray
      } else if (this.accountsTransForm.actionName === 'COMM_FILTER') {
        const commActionlist = Object.freeze(commAction)
        let convertCommActionArray = Object.keys(commActionlist).map(key => {
          return {
            label: commActionlist[key],
            value: key
          }
        })
        this.actions = convertCommActionArray
      } else {
        this.actions = []
      }
    },
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        if (this.initialLoad === false) {
          this.visibleTab = { ...data }
        }
      } else {
        this.visibleTab = {}
      }
    },
    doColumn(detailTab, columns) {
      this.resetValidator()
      this.resetMessages()
      this.columns = []
      this.accountsTransForm.includeBalance = false // OS-899 added
      this.getDetTab = detailTab
      if (detailTab === 'Accounts') {
        this.accountsTransForm.actionName = 'ACCT_MASTER_FILTER'
        this.accountsTransForm.transactions = 'Accounts'
        this.columns = Object.assign(this.columns, this.accountsColumns)
        this.selectedAccountsColumns = ['branch', 'type', 'docNo', 'acctNo', 'fund', 'suffix', 'tranDate', 'curr', 'netAmount', 'osBalance']
        this.showDetailFilters = false
      } else if (detailTab === 'GL Transactions') {
        this.accountsTransForm.actionName = 'GL_TRANS_FILTER'
        this.accountsTransForm.transactions = null
        this.accountsTransForm.actions = 'Both'
        this.columns = Object.assign(this.columns, this.glColumns)
      } else if (detailTab === 'Matched Details') {
        this.accountsTransForm.actionName = 'MCH_DET_FILTER'
        this.columns = Object.assign(this.columns, this.mdColumns)
      } else if (detailTab === 'Commission') {
        this.accountsTransForm.actionName = 'COMM_FILTER'
        this.columns = Object.assign(this.columns, this.commColumns)
      } else if (detailTab === 'Non-Trade') {
        this.accountsTransForm.actionName = 'NON_TRADE_FILTER'
        this.accountsTransForm.includeBalance = true // OS-899 added
        this.columns = Object.assign(this.columns, this.nonTradeColumns)
        this.accountsTransForm.transactions = 'Accounts'
      }
      this.doLoadActionList()
      if (this.initialLoad === false) {
        this.performSearch()
      }
    },
    doRemoveAccount(account) {
      this.delAccountForm.branch = account.branch
      this.delAccountForm.documentNo = account.docNo
      this.delAccountForm.accountNo = account.acctNo
      this.delAccountForm.accountNoSuffix = account.suffix
      this.delAccountForm.fund = account.fund
      this.delAccountForm.transactionType = account.type
      this.delAccountForm.transactionType2 = account.type2
      this.delAccountForm.actionName = 'DELETE_ACCOUNT'
      this.acctNoToRemove = account.branch + '-' + account.docNo + '-' + account.type
      this.accountsTransForm.delAcct = true
      this.accountsTransFormLabel.warnMsg = 'Are you sure you want to delete the selected account'

      if (account.postNow === 'Y') {
        this.doChkBatch(account).then(result => {
          this.doChkGLTran(account).then(result => {
            if (account.netAmount !== account.osBalance || account.zeroBal === true) {
              // Net Amount != OS Balance
              this.accountsTransFormLabel.warnMsg = 'Transaction has been matched - Cannot delete'
              this.accountsTransForm.delAcct = false
            } else if (this.accountsTransForm.matchBatchProcess === true) {
              // If found in acctMchDet
              this.accountsTransFormLabel.warnMsg = 'Transaction processed by batch program ' + this.accountsTransForm.matchCreatedProgId
              this.accountsTransForm.delAcct = false
            } else if (account.bankTranDate !== null && account.bankTranDate !== '') {
              // If Bank Transaction Date is not blank
              this.accountsTransFormLabel.warnMsg = 'Transaction has been reconciled with bank Statements - Cannot delete'
              this.accountsTransForm.delAcct = false
            } else if (this.accountsTransForm.glTranFound === true) {
              // If found the first child in GLTran
              if (this.accountsTransForm.glTranBchNo > 0) {
                // If glTRanBchNo != 0
                this.accountsTransFormLabel.warnMsg = 'Transaction has been posted to GL - cannot delete - Must VOID transaction'
                this.accountsTransForm.delAcct = false
              }
            } else if (this.accountsTransForm.glTranFound === false) {
              // Not found record in GLTran
              this.accountsTransFormLabel.warnMsg = 'This transaction is corrupted - please contact your system administrator'
              this.accountsTransForm.delAcct = false
            }

            if (this.accountsTransForm.delAcct) {
              if (
                account.chequePrtd === true ||
                account.bankListPrtd === 'Yes' ||
                account.bankPayInPrtd === 'Yes' ||
                account.docPrtd === 'Yes' ||
                account.brnDocListPrtd === 'Yes'
              ) {
                this.accountsTransFormLabel.warnMsg = 'Transaction has been printed document/cheques/reports - still delete'
              }
              if (account.bchMch === true) {
                this.accountsTransFormLabel.warnMsg2 = 'Transaction is set to be Batch Match'
              }
              this.warnMsg = this.accountsTransFormLabel.warnMsg
              this.warnMsg2 = this.accountsTransFormLabel.warnMsg2
              this.deleteAccount()
            } else {
              this.promptCannotRemoveAccount = true
            }
          })
        })
      } else {
        this.warnMsg = this.accountsTransFormLabel.warnMsg
        this.deleteAccount()
      }
    },
    doReview(data) {
      if (data.item) {
        if (data.item.postNow === 'N' && (data.item.tranGrp === 3 || data.item.tranGrp === 4 || data.item.tranGrp === 6)) {
          if (data.item.createdProgId === 'rcptEnt') {
            const commit = {
              branch: data.item.branch,
              acctNo: data.item.acctNo,
              type: data.item.type,
              docNo: data.item.docNo,
              fund: data.item.fund,
              suffix: data.item.suffix
            }
            this.$store.commit(RECEIPT_LOAD_DATA, commit)
            this.$router.push({ name: 'reviewReceipt' }).catch(() => {})
          } else if (data.item.createdProgId === 'paytEnt') {
            const commit = {
              tranMode: 'R',
              branch: data.item.branch,
              accountNo: data.item.acctNo,
              type: data.item.type,
              documentNo: data.item.docNo,
              fund: data.item.fund,
              suffix: data.item.suffix
            }
            this.$store.commit(PAYMENT_LOAD_DATA, commit)
            this.$router.push({ name: 'createPayment' }).catch(() => {})
          } else if (data.item.createdProgId === 'crdEnt') {
            const commit = {
              tranMode: 'R',
              branch: data.item.branch,
              accountNo: data.item.acctNo,
              type: data.item.type,
              documentNo: data.item.docNo,
              fund: data.item.fund,
              suffix: data.item.suffix
            }
            this.$store.commit(CREDITNOTE_LOAD_DATA, commit)
            this.$router.push({ name: 'createCreditNote' }).catch(() => {})
          } else if (data.item.createdProgId === 'debEnt') {
            const commit = {
              tranMode: 'R',
              branch: data.item.branch,
              accountNo: data.item.acctNo,
              type: data.item.type,
              documentNo: data.item.docNo,
              fund: data.item.fund,
              suffix: data.item.suffix
            }
            this.$store.commit(DEBITNOTE_LOAD_DATA, commit)
            this.$router.push({ name: 'createDebitNote' }).catch(() => {})
          }
        }
      }
    },
    doQuery(data) {
      if (data.item) {
        this.$store.commit(ACCOUNTS_LOAD_DATA, data.item)
        this.$router
          .push({ name: 'accountsDetails',
            params: {
              accountData: data.item,
              queryAcctMaster: true,
              fromAcctMaster: true,
              voidMultiAcct: false
            }
          }).catch(() => {})
      }
    },
    doTranType() {
      if (this.accountsTransForm.transactions === 'Accounts') {
        const list = Object.freeze(acctTrans)
        let convertArray = Object.keys(list).map(key => {
          return {
            label: key + ' - ' + list[key],
            value: key
          }
        })
        this.actions = ['Review', 'Matched', 'Query', 'Void']
        this.accountsTransForm['actions'] = 'Review'
        this.transactionType = convertArray
      }
      if (this.accountsTransForm.transactions === 'Underwriting') {
        const list = Object.freeze(unwTrans)
        let convertArray = Object.keys(list).map(key => {
          return {
            label: key + ' - ' + list[key],
            value: key
          }
        })
        this.actions = ['Instalments', 'Matched', 'Refund', 'Commission', 'Query', 'Void']
        this.accountsTransForm['actions'] = 'Instalments'

        this.transactionType = convertArray
        this.accountsTransForm.actions = 'Instalments'
      }
      if (this.accountsTransForm.transactions === 'Claims') {
        const list = Object.freeze(clmTrans)
        let convertArray = Object.keys(list).map(key => {
          return {
            label: key + ' - ' + list[key],
            value: key
          }
        })
        this.actions = ['Matched', 'Query', 'Void']
        this.accountsTransForm['actions'] = 'Matched'
        this.transactionType = convertArray
      }
      if (this.accountsTransForm.transactions === 'All Transactions') {
        const list = Object.freeze(allTrans)
        let convertArray = Object.keys(list).map(key => {
          return {
            label: key + ' - ' + list[key],
            value: key
          }
        })
        this.actions = ['Instalments', 'Matched', 'Refund', 'Commission', 'Query', 'Void']
        this.accountsTransForm['actions'] = 'Review'
        this.transactionType = convertArray
      }

      if (this.accountsTransForm.actions === 'Review') {
        this.accountsTransForm.includeBalance = null
      } else {
        this.accountsTransForm.includeBalance = false
      }

      // OS-899
      if (this.accountsTransForm.actionName === 'NON_TRADE_FILTER') {
        this.accountsTransForm.includeBalance = true
      }
    },
    doAction() {
      if (this.accountsTransForm.actionName === 'ACCT_MASTER_FILTER') {
        if (this.accountsTransForm.actions === 'Instalments') {
          this.accountsTransForm.enableDueDate = false
        } else {
          this.accountsTransForm.enableDueDate = true
        }

        if (this.accountsTransForm.actions === 'Matched') {
          this.accountsTransForm.enableLastMatchedDate = false
        } else {
          this.accountsTransForm.enableLastMatchedDate = true
        }

        this.accountsTransForm.includeVoidTransactions = null
        this.accountsTransForm.includeBalance = null

        if (this.accountsTransForm.transactions === 'Accounts' || this.accountsTransForm.transactions === 'All Transactions') {
          if (
            this.accountsTransForm.actions === 'Matched' ||
            this.accountsTransForm.actions === 'Instalments' ||
            this.accountsTransForm.actions === 'Refund' ||
            this.accountsTransForm.actions === 'Commission' ||
            this.accountsTransForm.actions === 'Query' ||
            this.accountsTransForm.actions === 'Void'
          ) {
            this.accountsTransForm.includeVoidTransactions = false
            this.accountsTransForm.includeBalance = false
          }
        }
      }

      // OS-899
      if (this.accountsTransForm.actionName === 'NON_TRADE_FILTER') {
        this.accountsTransForm.includeBalance = true
      }
    },
    doGLQuery(data) {
      this.showGLDetail = true
      this.glObjData = data.item
    },
    doMatchedQuery(data) {
      this.showMatchDetail = true
      this.matchObjData = data.item
    },
    doCommPVQuery(data) {
      this.showCommPVDetail = true
      this.commPVObjData = data.item
    },
    doShowNonTradeReviewAction(data) {
      if (data.postNow === 'N') {
        return true
      }
    },
    doNonTradeReview(data) {
      const dataInfo = {
        branch: data.item.ntBranch,
        accountNo: '',
        type: data.item.ntType,
        documentNo: data.item.ntDocNo,
        fund: data.item.ntFund,
        suffix: data.item.ntSuffix,
        tranMode: 'R'
      }
      this.$store.commit(NON_TRADE_LOAD_DATA, dataInfo)
      this.$router.push({ name: 'createNonTrade' }).catch(() => {})
      this.showNonTradeDetail = true
      this.nonTradeObjData = data.item
    },
    doNonTradeQuery(data) {
      if (data.item) {
        this.$store.commit(ACCOUNTS_LOAD_DATA, data.item)
        this.$router.push({ name: 'accountsDetails', params: { accountData: data.item } }).catch(() => {})
      }
    },
    assignClaimNo(claimNo) {
      this.accountsTransForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignDocNo(docNo) {
      this.accountsTransForm.documentNo = docNo
      this.showDocNoHelpList = false
    },
    assignCurrency(curr) {
      this.accountsTransForm.currency = curr
      this.showCurrHelpList = false
    },
    assignAcctNo(acctNo) {
      this.accountsTransForm.accountNo = acctNo
      this.showAcctNoHelpList = false
    },
    assignFund(fund) {
      this.accountsTransForm.fund = fund
      this.showFundHelpList = false
    },
    assignPolicy(polNo) {
      this.accountsTransForm.policyNo = polNo
      this.showPolicyHelpList = false
    },
    assignAcctSuf(acctNoSfx) {
      this.accountsTransForm.accountNoSuffix = acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignPayersCheq(payrChqNo) {
      this.accountsTransForm.payersChequeNo = payrChqNo
      this.showPayersChequeNoHelpList = false
    },
    assignBank(bankNo) {
      this.accountsTransForm.bankNo = bankNo
      this.showBankNoHelpList = false
    },
    assignAddressedTo(docName) {
      this.accountsTransForm.addressedTo = docName
      this.showAddrToHelpList = false
    },
    assignBillAcctNo(billAcctNo) {
      this.accountsTransForm.billingAccountNo = billAcctNo
      this.showBillAcctNoHelpList = false
    },
    assignGlAcctNo(glAcctNo) {
      this.accountsTransForm.glAccountNo = glAcctNo
      this.showGlAcctNoHelpList = false
    },
    assignContraDocNo(contraDocNo) {
      this.accountsTransForm.contraDocumentNo = contraDocNo
      this.showContraDocNoHelpList = false
    },
    assignOvrdAcctNo(ovrdAcctNo) {
      this.accountsTransForm.overridingAccountNo = ovrdAcctNo
      this.showOvrdAcctNoHelpList = false
    },
    doShowAction1(data) {
      if (data.transactions === 'Accounts' && data.actions === 'Review') {
        if (data.tranGrp === 6 || data.tranGrp === 3 || data.tranGrp === 4) {
          return true
        }
      }
    },
    doShowAction2(data) {
      if (data.transactions === 'Accounts' && data.actions !== 'Review') {
        return true
      }
    },
    doShowDelAction(data) {
      var isShow = false
      if (
        ((data.tranGrp === 6 && (data.createdProgId !== 'PostDiff' || data.createdProgId !== 'WOSB')) ||
          (data.tranGrp === 3 && data.createdProgId !== 'ClmRel') ||
          (data.tranGrp === 4 && data.createdProgId !== 'ClmRel')) &&
        data.postNow === 'N' &&
        data.void_ === false
      ) {
        isShow = true
      }
      return isShow
    },
    doShowAction3(data) {
      if (data.transactions === 'Underwriting' || data.transactions === 'Claims' || data.transactions === 'All Transactions') {
        return true
      }
    },
    closeDialog() {
      this.promptCannotRemoveAccount = false
    }
  },
  created() {},
  mounted() {},
  mixins: [routeMixin, MessageMixin, accountsListMixin, accountsAjaxCalls, accountsFilters, commonAjaxMixin],
  components: {
    AcctNoHelpList,
    ClaimHelpList,
    CrCurrencyHelpList,
    DocNoHelpList,
    FundHelpList,
    PolicyHelpList,
    AcctSufHelpList,
    PayersCheqHelpList,
    BankHelpList,
    AddressedToHelpList,
    BillAcctNoHelpList,
    GlAcctNoHelpList,
    ContraDocNoHelpList,
    OvrdAcctNoHelpList,
    GLTransDetail,
    MatchedTransDetail,
    CommPVTransDetail,
    SearchFilter,
    UpdateSearchFilter
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
